// Open (or create) a database

export { saveData, loadData, deleteDB };

const DBNAME = "Ziege"

function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DBNAME, 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;

            // Create an object store if it doesn't exist
            if (!db.objectStoreNames.contains("store")) {
                db.createObjectStore("store", { keyPath: "id" });
            }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

// Save data
async function saveData(data) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
        const transaction = db.transaction("store", "readwrite");
        const store = transaction.objectStore("store");

        const request = store.put(data); // put = insert or update

        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
        transaction.oncomplete = () => db.close();
    });
}

// Load data by id
async function loadData(id) {
    const db = await openDB();

    return new Promise((resolve, reject) => {
        const transaction = db.transaction("store", "readonly");
        const store = transaction.objectStore("store");

        const request = store.get(id);

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
        transaction.oncomplete = () => db.close();
    });
}

// Offene Verbindungen (z. B. im Service Worker) blockieren das Löschen nur, bis sie
// geschlossen werden; darauf wird nicht gewartet.
function deleteDB() {
    return new Promise((resolve) => {
        const request = indexedDB.deleteDatabase(DBNAME);
        request.onsuccess = request.onerror = request.onblocked = () => resolve();
    });
}
